import { render, staticRenderFns } from "./RenameFileDialog.vue?vue&type=template&id=4cf3c673&v-slot%3Amodal-body=true&"
import script from "./RenameFileDialog.vue?vue&type=script&lang=js&"
export * from "./RenameFileDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports